import * as R from "ramda";

export const maximumSpeedColor = "#427D00";
export const regularSpeedColor = "#3693ff";
export const minimumSpeedColor = "#e60000"

export const getReportColor = (currentSpeed: number | null, maxSpeed?: number | null, avgSpeed?: number | null, minSpeed?: number | null): string => {

    if (R.isNil(currentSpeed) || R.isNil(maxSpeed)) {
        return "#333333";        
    }

    const avg = R.isNil(avgSpeed) ? maxSpeed * 0.5 : avgSpeed;
    const min = R.isNil(minSpeed) ? maxSpeed * 0.2 : minSpeed;

    if (currentSpeed <= min) {
        return minimumSpeedColor;
    }

    if (avg < currentSpeed) {
        return maximumSpeedColor;
    }

    return regularSpeedColor;
}